import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import dayjs from "dayjs";
import PrintJobNiceloopV1Builder from "~/class/printer/PrintJobNiceloopV1Builder";


export default class ThermalPrintJob extends ThermalPrinterBase {  
    printToKitchen(job : any, options:any){  
      const jobKitchen = this.withPayload(job, options)
      console.log("jobKitchen=>", jobKitchen)
      this.print_data = jobKitchen
      return this
    } 
    
    withPayload(job : any, options:any){  
      const printJobBuilder =  new PrintJobNiceloopV1Builder(options?.productsStore)
      const serviceValue = printJobBuilder.getBillArrValue(options?.billing?.serviceCharge, 2) || 0
      const vatValue = printJobBuilder.getBillArrValue(options?.billing?.vat, 1) || 0
      const vatMode = printJobBuilder.getBillArrValue(options?.billing?.vat, 0) || 0

      const payload = {
        ...job,
        ...options,
        serviceValue,
        vatValue,
        vatMode,            
      }
 

      const jobKitchen = printJobBuilder.makePrintJobKitchen(payload).build();

      console.log("jobKitchen=>", jobKitchen)
      return jobKitchen
    }  
    
    setPayload(printPayload:any){
      this.print_data = printPayload
      return this
    }
}
